import { X } from "lucide-react";
import "../VideoControls.css";

export const UserListModal = ({ isOpen, onClose, users, roomId, roomName }) => {
  const userName = JSON.parse(sessionStorage.getItem("username"))

  if (!isOpen) return null;

  if (!users || typeof users !== "object") {
    console.warn("Invalid users data! Resetting to empty object.");
    users = {};
  }

  const roomUsers = Object.entries(users)
    ?.filter(([_, user]) => user?.roomId === String(roomId))
    ?.map(([peerId, user]) => ({
      peerId,
      username: user?.username || "Unknown User",
    }));

  return (
    <>
      <div
        className={`modal-overlay ${isOpen ? "open" : ""}`}
        onClick={onClose}
      />
      <div className={`user-list-modal ${isOpen ? "open" : ""}`}>
        <div className="modal-header">
          <h3>Room {roomName}</h3>
          <button className="close-button" onClick={onClose}>
            <X size={20} />
          </button>
        </div>
        <h3 className="modal-title">Participants ({roomUsers.length})</h3>
        <div className="user-list">
          {roomUsers.length > 0 ? (
            roomUsers.map(({ peerId, username }) => (
              <div key={peerId} className="user-list-item">
                <div className="status-indicator" />
                <span>{String(username) === userName ? (String(username).length > 18 ? `${String(username).slice(0, 18)}... (You)` : `${String(username)} (You)`) : (String(username).length > 18 ? `${String(username).slice(0, 18)}...` : `${String(username)}`)}</span>
              </div>
            ))
          ) : (
            <p>No participants yet</p>
          )}
        </div>

      </div>
    </>
  );
};
